<mat-menu #menu="matMenu" class="sg-menu-overlay sg-ui-component" [hasBackdrop]="hasBackdrop">
  @if (!hasGroups && !hasItems) {
  <button mat-menu-item [disabled]="true" class="sg-menu--no-items sg-ui-component">
    No menu items provided. Please set either 'groups' or 'items' input.
  </button>
  } @if (hasGroups) { @for (group of groups; track trackByGroupId($index, group)) { @if (group.label && !group.labelHtml) {
  <sg-text variant="sg-body-small-bold" class="sg-menu-group-label">{{ group.label }}</sg-text>
  } @if (group.labelHtml) {
  <sg-text variant="sg-body-small-bold" class="sg-menu-group-label" [innerHTML]="getSafeHtml(group.labelHtml)"></sg-text>
  } @for (item of group.items; track trackByItemId($index, item)) { @if (!item.children || item.children.length === 0) {
  <button
    mat-menu-item
    class="sg-ui-component"
    [class.sg-menu-item--selected]="item.isSelected"
    [class.sg-menu-item--disabled]="item.isDisabled"
    [class.sg-menu-item--readonly]="item.readonly"
    [disabled]="item.isDisabled"
    [attr.data-test]="item.id"
    (click)="onItemClick(item, group, $event)"
    [style.cursor]="item.readonly ? 'default' : null">
    @if (item.icon) {
    <mat-icon class="sg-menu-item__prefix-icon sg-ui-component">{{ item.icon }}</mat-icon>
    } @if (item.label && !item.labelHtml) {
    <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label">{{ item.label }}</sg-text>
    } @if (item.labelHtml) {
    <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label" [innerHTML]="getSafeHtml(item.labelHtml)"></sg-text>
    } @if (item.showToggle && !item.isDisabled) {
    <sg-toggle
      class="sg-menu-item__suffix-toggle"
      [checked]="item.toggleValue"
      (checkedChange)="onToggleChange($event, item, group)"
      (click)="$event.stopPropagation()"></sg-toggle>
    } @if (getSuffixIcon(item, group) && !item.showToggle && (!item.children || item.children.length === 0)) {
    <mat-icon
      class="sg-menu-item__suffix-icon sg-ui-component"
      [class.sg-menu-item__suffix-icon--clickable]="item.suffixIcon"
      [svgIcon]="getSuffixIcon(item, group).startsWith('sg-') ? getSuffixIcon(item, group) : null"
      (click)="onSuffixIconClick($event, item, group)">
      {{ getSuffixIcon(item, group).startsWith('sg-') ? '' : getSuffixIcon(item, group) }}
    </mat-icon>
    }
  </button>
  } @if (item.children && item.children.length > 0) {
  <div class="sg-submenu-container">
    <button mat-menu-item [matMenuTriggerFor]="submenu" [class.sg-menu-item--disabled]="item.isDisabled" [disabled]="item.isDisabled" class="sg-ui-component">
      @if (item.icon) {
      <mat-icon class="sg-menu-item__prefix-icon sg-ui-component" [svgIcon]="item.icon.startsWith('sg-') ? item.icon : null">
        {{ item.icon.startsWith('sg-') ? '' : item.icon }}
      </mat-icon>
      } @if (item.label && !item.labelHtml) {
      <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label">{{ item.label }}</sg-text>
      } @if (item.labelHtml) {
      <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label" [innerHTML]="getSafeHtml(item.labelHtml)"></sg-text>
      }
      <mat-icon class="sg-menu-item__submenu-arrow sg-ui-component">keyboard_arrow_right</mat-icon>
    </button>
    <mat-menu #submenu="matMenu" class="sg-submenu-overlay sg-ui-component" [hasBackdrop]="hasBackdrop">
      @for (subItem of item.children; track trackByItemId($index, subItem)) {
      <button
        mat-menu-item
        class="sg-ui-component"
        [class.sg-menu-item--selected]="subItem.isSelected"
        [class.sg-menu-item--disabled]="subItem.isDisabled"
        [class.sg-menu-item--readonly]="subItem.readonly"
        [disabled]="subItem.isDisabled"
        (click)="onItemClick(subItem, group, $event)"
        [style.cursor]="subItem.readonly ? 'default' : null">
        @if (subItem.icon) {
        <mat-icon class="sg-menu-item__prefix-icon sg-ui-component">{{ subItem.icon }}</mat-icon>
        } @if (subItem.label && !subItem.labelHtml) {
        <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label">{{ subItem.label }}</sg-text>
        } @if (subItem.labelHtml) {
        <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label" [innerHTML]="getSafeHtml(subItem.labelHtml)"></sg-text>
        } @if (subItem.showToggle && !subItem.isDisabled) {
        <sg-toggle
          class="sg-menu-item__suffix-toggle"
          [checked]="subItem.toggleValue"
          (checkedChange)="onToggleChange($event, subItem, group)"
          (click)="$event.stopPropagation()"></sg-toggle>
        } @if (getSuffixIcon(subItem, group) && !subItem.showToggle) {
        <mat-icon
          class="sg-menu-item__suffix-icon sg-ui-component"
          [class.sg-menu-item__suffix-icon--clickable]="subItem.suffixIcon"
          [svgIcon]="getSuffixIcon(subItem, group).startsWith('sg-') ? getSuffixIcon(subItem, group) : null"
          (click)="onSuffixIconClick($event, subItem, group)">
          {{ getSuffixIcon(subItem, group).startsWith('sg-') ? '' : getSuffixIcon(subItem, group) }}
        </mat-icon>
        }
      </button>
      @if (subItem.dividerAfter) {
      <mat-divider class="sg-menu-divider sg-ui-component"></mat-divider>
      } }
    </mat-menu>
  </div>
  } @if (item.dividerAfter) {
  <mat-divider class="sg-menu-divider sg-ui-component"></mat-divider>
  } } } } @if (!hasGroups && hasItems) { @for (item of items; track trackByItemId($index, item)) {
  <button
    mat-menu-item
    class="sg-ui-component"
    [class.sg-menu-item--selected]="item.isSelected"
    [class.sg-menu-item--disabled]="item.isDisabled"
    [class.sg-menu-item--readonly]="item.readonly"
    [disabled]="item.isDisabled"
    [attr.data-test]="item.id"
    (click)="onItemClick(item, undefined, $event)"
    [style.cursor]="item.readonly ? 'default' : null">
    @if (item.icon) {
    <mat-icon class="sg-menu-item__prefix-icon sg-ui-component" [svgIcon]="item.icon.startsWith('sg-') ? item.icon : null">
      {{ item.icon.startsWith('sg-') ? '' : item.icon }}
    </mat-icon>
    } @if (item.label && !item.labelHtml) {
    <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label">{{ item.label }}</sg-text>
    } @if (item.labelHtml) {
    <sg-text variant="sg-body-medium-regular" class="sg-menu-item__label" [innerHTML]="getSafeHtml(item.labelHtml)"></sg-text>
    } @if (item.showToggle && !item.isDisabled) {
    <sg-toggle
      class="sg-menu-item__suffix-toggle"
      [checked]="item.toggleValue"
      (checkedChange)="onToggleChange($event, item)"
      (click)="$event.stopPropagation()"></sg-toggle>
    } @if (getSuffixIcon(item) && !item.showToggle) {
    <mat-icon
      class="sg-menu-item__suffix-icon sg-ui-component"
      [class.sg-menu-item__suffix-icon--clickable]="item.suffixIcon"
      [svgIcon]="getSuffixIcon(item).startsWith('sg-') ? getSuffixIcon(item) : null"
      (click)="onSuffixIconClick($event, item)">
      {{ getSuffixIcon(item).startsWith('sg-') ? '' : getSuffixIcon(item) }}
    </mat-icon>
    }
  </button>
  @if (item.dividerAfter) {
  <mat-divider class="sg-menu-divider sg-ui-component"></mat-divider>
  } } }
</mat-menu>
